module.exports = __webpack_public_path__ + "img/img1.cf7d221f.jpg";